"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _reactIcons = require("@100mslive/react-icons");
var _useSidepane = require("./AppData/useSidepane");
var _useUISettings = require("./AppData/useUISettings");
var _constants = require("./../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
var GoLiveButton = function GoLiveButton() {
  var isStreamingSidepaneOpen = (0, _useSidepane.useIsSidepaneTypeOpen)(_constants.SIDE_PANE_OPTIONS.STREAMING);
  var toggleStreaming = (0, _useSidepane.useSidepaneToggle)(_constants.SIDE_PANE_OPTIONS.STREAMING);
  var _useRecordingStreamin = (0, _reactSdk.useRecordingStreaming)(),
    isStreamingOn = _useRecordingStreamin.isStreamingOn,
    isBrowserRecordingOn = _useRecordingStreamin.isBrowserRecordingOn;
  var isHLSStartedFromUI = (0, _useUISettings.useIsHLSStartedFromUI)();
  var isRTMPStartedFromUI = (0, _useUISettings.useIsRTMPStartedFromUI)();
  var tooltipText = "Start streaming";
  if (isHLSStartedFromUI || isRTMPStartedFromUI) {
    if (isHLSStartedFromUI) {
      tooltipText = "HLS start in progress";
    }
    if (isRTMPStartedFromUI) {
      tooltipText = "RTMP start in progress";
    }
  }
  if (isStreamingOn) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
    title: tooltipText,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Button, {
      "data-testid": "go_live",
      variant: isStreamingSidepaneOpen ? "standard" : "primary",
      onClick: toggleStreaming,
      icon: true,
      loading: isRTMPStartedFromUI || isHLSStartedFromUI,
      disabled: isBrowserRecordingOn && !isStreamingOn,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.GoLiveIcon, {}), "Go Live"]
    })
  });
};
var _default = GoLiveButton;
exports["default"] = _default;